// material-ui
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';

// assets
import { FallOutlined, RiseOutlined } from '@ant-design/icons';

import Divider from '@mui/material/Divider';
import IncomeAreaChart from '../../../pages/dashboard/IncomeAreaChart';
// project import
import MainCard from '../../../components/MainCard';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

// ==============================|| STATISTICS - ECOMMERCE CARD  ||============================== //

const DashboardHelper = ({ color, title, count, isLoss }) => {
  const theme = useTheme();

  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    const increment = Math.ceil(count / 100); // Adjust speed by changing divisor
    const duration = 300; // Animation duration in ms
    const interval = duration / (count / increment);

    const counter = setInterval(() => {
      setDisplayCount(prevCount => {
        const nextCount = prevCount + increment;
        if (nextCount >= count) {
          clearInterval(counter);
          return count;
        }
        return nextCount;
      });
    }, interval);

    return () => clearInterval(counter);
  }, [count]);

  return (
    <MainCard
      contentSX={{ p: 2.25 }}
      size='sm'
      sx={{ bgcolor: 'inherit', boxShadow: theme.customShadows.z1 }}
    >
      <Stack spacing={0.5}>
        <Grid container justifyContent='space-between' alignItems='center'>
            <Box>
              <Typography variant='h5' color='rgb(237, 6, 119)'>
                {title}
              </Typography>
            </Box>
            <Box sx={{
              borderLeft: '0.5px solid #bbbbbb',
              paddingLeft: '30px',
              marginRight: '20px'
            }}>
              <Box >
              <Typography variant='h4' color='rgb(3, 78, 162)'>
                {displayCount}
              </Typography>
              </Box>
            </Box>
          {/* <Divider orientation='vertical' flexItem sx={{ mr: '-1px' }} /> */}

          {/* <Grid item xs={4} sm={4} md={4} lg={4}>
            <Chip
              variant='combined'
              color={color}
              icon={
                <>
                  {!isLoss && (
                    <RiseOutlined
                      style={{ fontSize: '0.75rem', color: 'inherit' }}
                    />
                  )}
                  {isLoss && (
                    <FallOutlined
                      style={{ fontSize: '0.75rem', color: 'inherit' }}
                    />
                  )}
                </>
              }
              sx={{ ml: 4, pl: 2 }}
              size='sm'
            />
          </Grid> */}
          {/* <Grid
            item
            xs={5}
            sm={5}
            md={5}
            lg={5}
            style={{
              paddingLeft: '10px',
              borderStyle: 'solid',
              borderColor: 'rgba(0, 0, 0, 0.12)',
              borderWidth: '0 0 0 1px',
            }}
          >
            <IncomeAreaChart />
          </Grid> */}
        </Grid>
      </Stack>
      {/* <Box sx={{ pt: 2.25 }}>
      <Typography variant="caption" color="textSecondary">
        You made an extra{' '}
        <Typography component="span" variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
          {extra}
        </Typography>{' '}
        this year
      </Typography>
    </Box> */}
    </MainCard>
  );
};

DashboardHelper.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.string,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  extra: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

DashboardHelper.defaultProps = {
  color: 'primary',
};

export default DashboardHelper;
